(function() {
  'use strict';

  angular.module('eclipseApp.core').factory('samKeyService', [
    '$timeout',
    '$rootScope',
    '$localStorage',
    '$q',
    'uteModal',
    '$state',
    '$http',
    'uteEndpoint',
    'uteLocale',
    'brt',
    '$templateCache',
    'brtSwitchCMS',
    function(
      $timeout,
      $rootScope,
      $localStorage,
      $q,
      uteModal,
      $state,
      $http,
      uteEndpoint,
      uteLocale,
      brt,
      $templateCache,
      brtSwitchCMS
    ) {
      return {
        tier: null,
        iptv: {
          offerExistsInOffersList: function(tier, samKey) {
            //Todo: Internet TV endpoint check
            var defer = $q.defer();

            // simulated async function
            $timeout(function() {
              defer.resolve({ data: { offerExist: true } });
            }, 0);

            return defer.promise;
          }
        },
        internet: {
          // check if offer exists in list of offers
          offerExistsInOffersList: function(tier, samKey, flow) {
            var _isBRTPeriod = brt.isBRTPeriod(),
              _isBRTSession = brt.isBRTSession();

            var _isNetNewCX = !_isBRTPeriod && !_isBRTSession ? true : _isBRTPeriod && !_isBRTSession ? false : true;
            var isBtsOffer = flow === 'btsPromotion' ? 'true' : 'false';

            var deferred = $q.defer();

            deferred.resolve({ data: { offerExist: true, error: null } });

            return deferred.promise;
          }
        },

        /**
         * returns the $rootScope.atg.samKey object
         * @returns {object}
         */
        getSamKey: function() {
          return $rootScope.userPref.samKey;
        },

        /**
         * sets the $rootScope.atg.samKey
         * @param samKeyObject
         */
        setSamKey: function(samKeyObject) {
          $rootScope.userPref.samKey = samKeyObject.value;
        },

        /*
         *
         */
        resetSamKey: function() {
          $rootScope.userPref.samKey = 'default';
        },

        /**
         * check to see if samKey is defined in rootScope.atg object
         * @returns {boolean}
         */
        isServiceable: function() {
          var deferred = $q.defer();

          if ($rootScope.userPref.samKey !== '' && $rootScope.userPref.samKey !== 'default') {
            deferred.resolve($rootScope.userPref.samKey);
          } else {
            deferred.reject($rootScope.userPref.samKey);
          }

          return deferred.promise;
        },

        /**
         * opens availability modal with #canadapost
         */
        showAvailabilityModal: function(service, tier, state) {
          var deferred = $q.defer();

          var modalConfig = {
            ok: function() {
              deferred.resolve();
            },
            cancel: function() {
              deferred.reject();
            }
          };

          // modalConfig.templateUrl = 'views/templates/modal/check-availability.html';
          modalConfig.controller = 'availabilityModalCtrl';

          // modalConfig.templateUrl = brt.getTemplateProvider('views/templates/modal/check-availability.html', 'views/');
          modalConfig.templateUrl = 'views/templates/modal/check-availability.html';

          // canada post equals true
          modalConfig.cp = true;
          modalConfig.data = {
            language: uteLocale.language,
            province: uteLocale.province,
            service: service,
            tier: tier || null,
            targetState: state || null
          };

          uteModal.open(modalConfig);

          return deferred.promise;
        }
      };
    }
  ]);
})();
